<template>
  <v-dialog v-model="dialog" max-width="800px" scrollable>
    <template v-slot:activator="{ on }">
      <v-btn fixed dark fab bottom right color="pink" v-on="on">
        <v-icon> fa fa-plus </v-icon>
      </v-btn>
    </template>
    <v-form ref="form" @submit.prevent="salvar">
      <v-card>
        <v-card-title class="headline primary white--text" primary-title>
          {{ cliente.id ? "Editar Cliente" : "Novo Cliente" }}
          <v-spacer></v-spacer>
          <v-icon dark @click="dialog = false">fa fa-times</v-icon>
        </v-card-title>
        <v-card-text style="height:500px;">
          <v-container fluid grid-list-md>
            <v-layout row wrap justify-center>
              <v-flex xs12>
                <v-text-field
                  v-model="cliente.nmcliente"
                  label="Nome"
                  prepend-icon="fa fa-user"
                  :error-messages="nomeErrors"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field
                  v-model="cliente.telefone"
                  label="Telefone"
                  prepend-icon="fa fa-phone"
                  mask="(##)####-####"
                  hint="(##)####-####"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field
                  v-model="cliente.email"
                  label="Email"
                  prepend-icon="fa fa-envelope"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-menu
                  v-model="dataMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      :value="dataFormatada"
                      label="Aniversário"
                      prepend-icon="fa fa-calendar"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="cliente.aniversario"
                    :max="new Date().toISOString().substr(0, 10)"
                    locale="pt-br"
                    no-title
                    @input="dataMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field
                  v-model="cliente.cpf"
                  label="CPF"
                  prepend-icon="fa fa-key"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field
                  v-model="cliente.facebook"
                  label="Facebook"
                  prepend-icon="fab fa-facebook-f"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field
                  v-model="cliente.instagram"
                  label="Instagram"
                  prepend-icon="fab fa-instagram"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field
                  v-model="cliente.twitter"
                  label="Twitter"
                  prepend-icon="fab fa-twitter"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field
                  v-model="cliente.linkedin"
                  label="LinkedIn"
                  prepend-icon="fab fa-linkedin-in"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn type="submit" @click.prevent="salvar" flat color="success">
            Confirmar
            <v-icon small right>fa fa-check</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
import axios from "axios";
import { required } from "vuelidate/lib/validators";
export default {
  name: "FormCliente",
  data() {
    return {
      cliente: {
        nmcliente: "",
        telefone: "",
        email: "",
        aniversario: "",
        cpf: "",
        facebook: "",
        instagram: "",
        twitter: "",
        linkedin: "",
        idempresa: this.$store.getters.user.idempresa
      },
      dataMenu: false
    };
  },
  props: {
    value: Boolean,
    item: Object
  },
  watch: {
    dialog(val) {
      if (!val) this.$refs.form.reset();
    },
    item(val) {
      if (val) this.cliente = val;
    }
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    dataFormatada() {
      return this.formatarData(this.cliente.aniversario);
    },
    nomeErrors() {
      const errors = [];
      if (!this.$v.cliente.nmcliente.$dirty) return errors;
      !this.$v.cliente.nmcliente.required && errors.push("Campo obrigatorio.");
      return errors;
    }
  },
  validations: {
    cliente: {
      nmcliente: { required }
    }
  },
  methods: {
    formatarData(data) {
      if (!data) return null;
      const [ano, mes, dia] = data.split("-");
      return `${dia}/${mes}/${ano}`;
    },
    salvar() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        if (!this.cliente.idcliente)
          axios.post("cliente/create", this.cliente).then(() => {
            this.close();
          });
        else
          axios
            .put(`cliente/update/${this.cliente.idcliente}`, this.cliente)
            .then(() => {
              this.close();
            });
      }
    },
    close() {
      this.dialog = false;
      this.$emit("load-clientes");
      this.$refs.form.reset();
      this.$v.$reset();
    }
  }
};
</script>
